import { render, staticRenderFns } from "./AboutTwo.vue?vue&type=template&id=86d4b41c&"
import script from "./AboutTwo.vue?vue&type=script&lang=js&"
export * from "./AboutTwo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports